import React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

const SignUpLink = ({ onSignUpClick }) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const handleSignUpClick = () => {
        if (onSignUpClick) {
            onSignUpClick();
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Typography
                sx={{
                    color: theme => theme.palette.figma.white[60],
                    fontSize: '14px',
                    fontWeight: 500,
                    letterSpacing: '-0.42px',
                }}
            >
                {t('don_t_have_an_account')}
            </Typography>
            <Typography
                sx={{
                    color: theme => theme.palette.figma.Red_didim,
                    fontSize: '14px',
                    fontWeight: 500,
                    letterSpacing: '-0.42px',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    '&:hover': {
                        color: theme => theme.palette.primary.dark,
                    },
                }}
                onClick={handleSignUpClick}
            >
                {t('sign_up')}
            </Typography>
        </Box>
    );
};

export default SignUpLink;
